import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "main-table" }
const _hoisted_3 = { class: "main-table__col main-table__col--title" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "main-table__col main-table__col--title" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "main-table__col main-table__col--value" }
const _hoisted_9 = { class: "main-table__col main-table__col--value" }
const _hoisted_10 = { class: "main-table__col main-table__col--value" }
const _hoisted_11 = { class: "main-table__col main-table__col--nested" }
const _hoisted_12 = { class: "main-table__col main-table__col--value" }
const _hoisted_13 = { class: "main-table__col main-table__col--value" }
const _hoisted_14 = { class: "main-table__col main-table__col--value" }
const _hoisted_15 = { class: "main-table__col main-table__col--title" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "main-table__col main-table__col--value" }
const _hoisted_19 = { class: "main-table__col main-table__col--value" }
const _hoisted_20 = { class: "main-table__col main-table__col--value" }
const _hoisted_21 = { class: "main-table__col main-table__col--nested" }
const _hoisted_22 = { class: "main-table__col main-table__col--value" }
const _hoisted_23 = { class: "main-table__col main-table__col--value" }
const _hoisted_24 = { class: "main-table__col main-table__col--value" }

import { ref, onMounted, onBeforeUnmount, watch, computed } from "vue";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import IconChevronUp from "@/assets/icons/IconChevronUp.vue";
import { paramsList } from "@/composables/list/params.list";
import { citiesList } from "@/composables/list/cities.list";
import {useStore} from "@/stores";
import TableLoader from "@/components/ui/loaders/TableLoader.vue";
import TableEmptyData from "@/components/ui/loaders/TableEmptyData.vue";
import type {FileData, StatisticsData} from "@/types/files";
import type {DistrictKey} from "@/composables/functions/getDistrictName";
import type {RegionKey} from "@/composables/functions/getRegionName";
import {districtList} from "@/composables/list/district.list";
import {regionToDistrictList} from "@/composables/list/regionToDistrict.list";

// Types
type ParameterValue = StatisticsData;

interface MainTableProps {
  items: FileData[];
  paramsSearchQuery: string;
  selectedRegions: string[];
  loading: boolean;
  selectedDistrictKey?: DistrictKey | null;
  selectedRegionKey?: RegionKey | null;
}

interface Column {
  key: string;
  label: string;
}

// store

export default /*@__PURE__*/_defineComponent({
  __name: 'DatabaseTable',
  props: {
    items: {},
    paramsSearchQuery: {},
    selectedRegions: {},
    loading: { type: Boolean },
    selectedDistrictKey: {},
    selectedRegionKey: {}
  },
  setup(__props: any) {

const mainStore = useStore();

// Props
const props = __props;

// Список колонок. БЕЗ Прогноза.
const COLUMNS: Column[] = [
  { key: "param_name", label: "Название параметра" },
  { key: "date_period", label: "Отчетный период" },
  { key: "appg", label: "АППГ" },
  { key: "appg_percent", label: "% к АППГ" },
];

// Конфигурация вложенных параметров
const NESTED_PARAMS: Record<string, string[]> = {
  cases_accepted: [
    "cases_transferred_without_indictment",
    "percent_transferred_without_indictment",
    "cases_transferred_with_indictment",
    "percent_transferred_with_indictment",
  ],
  percent_cases_returned_to_prosecutor: [
      "cases_returned_by_prosecutor",
      "percent_cases_returned_by_prosecutor",
      "cases_returned_by_court_article_237"
  ],
  cases_completed_overtime: [
      "cases_resumed_from_suspended"
  ]
};

// Refs
const scrollContainer = ref<HTMLElement | null>(null);
const hasScroll = ref(false);
const expandedRows = ref<Set<string>>(new Set());
const expandedParams = ref<Set<string>>(new Set());
const expandedDistricts = ref<Set<DistrictKey>>(new Set());

const isRowExpanded = (rowId: string) => expandedRows.value.has(rowId);
const isParamExpanded = (paramId: string) => expandedParams.value.has(paramId);
const isDistrictExpanded = (districtKey: DistrictKey) => expandedDistricts.value.has(districtKey);

// Режим отображения с федеральными округами
const showDistrictsMode = computed(() => {
  return !props.selectedDistrictKey && !props.selectedRegionKey;
});

// Фильтрация регионов по округу
const getRegionsForDistrict = (districtKey: DistrictKey): FileData[] => {
  return props.items.filter(item =>
    regionToDistrictList[item.region as keyof typeof regionToDistrictList] === districtKey
  );
};

// Функция. Раскрытие списка регионов
const toggleRowExpansion = (rowId: string) => {
  const newSet = new Set(expandedRows.value);
  if (newSet.has(rowId)) {
    newSet.delete(rowId);
  } else {
    newSet.add(rowId);
  }
  expandedRows.value = newSet;
  updateScroll();
};

// Функция. Раскрытия списка вложенных параметров
const toggleParamExpansion = (paramId: string) => {
  const newSet = new Set(expandedParams.value);
  if (newSet.has(paramId)) {
    newSet.delete(paramId);
  } else {
    newSet.add(paramId);
  }
  expandedParams.value = newSet;
  updateScroll();
};

// Функция. Раскрытие федерального округа
const toggleDistrictExpansion = (districtKey: DistrictKey) => {
  const newSet = new Set(expandedDistricts.value);
  if (newSet.has(districtKey)) {
    newSet.delete(districtKey);
  } else {
    newSet.add(districtKey);
  }
  expandedDistricts.value = newSet;
  updateScroll();
};

// Проверка, есть ли вложенные параметры.
const hasNestedParams = (paramKey: string): boolean => {
  return paramKey in NESTED_PARAMS;
};

// Функция. Получения вложенных параметров.
const getNestedParams = (row: FileData, parentKey: string): Array<{ key: string; value: ParameterValue }> => {
  const nestedKeys = NESTED_PARAMS[parentKey] || [];
  return nestedKeys
      .map((key) => {
        const value = (row)[key];
        if (typeof value === "object" && value !== null) {
          return { key, value: value as ParameterValue };
        }
        return null;
      })
      .filter((item): item is { key: string; value: ParameterValue } => item !== null);
};

// Получение наименования региона по ключу
const getRegionName = (regionKey: string): string => {
  return citiesList[regionKey as keyof typeof citiesList] || regionKey;
};

// Получение наименования параметра по ключу
const getParameterName = (paramKey: string): string => {
  return paramsList[paramKey as keyof typeof paramsList] || paramKey;
};


const getRowParameters = (row: FileData): Array<{ key: string; value: ParameterValue }> => {
  // Собираем все вложенные параметры в один Set для быстрой проверки
  const nestedParamsSet = new Set<string>();
  Object.values(NESTED_PARAMS).forEach((nestedKeys) => {
    nestedKeys.forEach((key) => nestedParamsSet.add(key));
  });

  const allParams = Object.entries(row)
      .filter(([key, value]) => {
        // Исключаем вложенные параметры из основного списка
        if (nestedParamsSet.has(key)) return false;
        return typeof value === "object" && value !== null;
      })
      .map(([key, value]) => ({ key, value: value as ParameterValue }));

  // Фильтрация по поисковому запросу
  if (props.paramsSearchQuery && props.paramsSearchQuery.length > 2) {
    const query = props.paramsSearchQuery.toLowerCase().trim();
    return allParams.filter(param => {
      const paramName = getParameterName(param.key).toLowerCase();
      return paramName.includes(query);
    });
  }

  return allParams;
};

// Проверка, есть ли совпадения в параметрах строки
const hasMatchingParams = (row: FileData): boolean => {
  if (!props.paramsSearchQuery || props.paramsSearchQuery.length <= 2) {
    return true;
  }
  return getRowParameters(row).length > 0;
};

// PerfectScrollbar
const checkScrollPresence = () => {
  if (scrollContainer.value) {
    hasScroll.value = scrollContainer.value.scrollHeight > scrollContainer.value.clientHeight;
  }
};

const updateScroll = () => {
  setTimeout(() => {
    checkScrollPresence();
    ps?.update();
  }, 0);
};

let ps: PerfectScrollbar | null = null;
let resizeObserverInstance: ResizeObserver | null = null;

const initializeScrollbar = () => {
  if (!scrollContainer.value) return;

  ps = new PerfectScrollbar(scrollContainer.value, {
    wheelSpeed: 1,
    wheelPropagation: false,
    minScrollbarLength: 20,
  });

  checkScrollPresence();

  resizeObserverInstance = new ResizeObserver(() => {
    checkScrollPresence();
    ps?.update();
  });

  resizeObserverInstance.observe(scrollContainer.value);
};

const destroyScrollbar = () => {
  if (resizeObserverInstance) {
    resizeObserverInstance.disconnect();
    resizeObserverInstance = null;
  }

  if (ps) {
    ps.destroy();
    ps = null;
  }
};

// Автоматическое раскрытие строк при поиске > 2 символов
watch(() => props.paramsSearchQuery, (newQuery) => {
  if (newQuery && newQuery.length > 2) {
    // Раскрываем все строки, которые имеют совпадения
    const newExpandedRows = new Set<string>();
    props.items.forEach(row => {
      if (hasMatchingParams(row)) {
        newExpandedRows.add(row.file_id);
      }
    });
    expandedRows.value = newExpandedRows;
  } else if (newQuery.length === 0) {
    // Закрываем все строки при очистке поиска
    expandedRows.value = new Set();
  }

  updateScroll();
});

// Автоматическое раскрытие строк при обновлении данных (если выбрано >= 1 региона)
watch(() => props.items, () => {
  if (props.selectedRegions && props.selectedRegions.length >= 1) {
    // Раскрываем все строки при загрузке новых данных
    const newExpandedRows = new Set<string>();
    props.items.forEach(row => {
      newExpandedRows.add(row.file_id);
    });
    expandedRows.value = newExpandedRows;
    updateScroll();
  }
});

onMounted(() => {
  initializeScrollbar();
});

onBeforeUnmount(() => {
  destroyScrollbar();
});

// Обновление позиции скролла при измение элементов таблицы.
watch(() => props.items, () => {
  updateScroll();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([{ 'main-table__header--with-scroll': hasScroll.value, 'main-table__header--forecast': _unref(mainStore).forecastStatusDisplay }, "main-table__header main-table__row main-table__row--header"])
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(COLUMNS, (column) => {
          return _createElementVNode("div", {
            key: column.key,
            class: "main-table__col main-table__col--header"
          }, _toDisplayString(column.label), 1)
        }), 64)),
        (_unref(mainStore).forecastStatusDisplay)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([{'main-table__col--forecast-header': _unref(mainStore).forecastStatusDisplay}, "main-table__col main-table__col--header"])
            }, " Прогноз ", 2))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        ref_key: "scrollContainer",
        ref: scrollContainer,
        class: "main-table__body"
      }, [
        (showDistrictsMode.value)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(districtList), (districtName, districtKey) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: districtKey }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["main-table__row main-table__row--title", { 'main-table__row--with-scroll': hasScroll.value,
                        'main-table__row--expanded': isDistrictExpanded(districtKey as DistrictKey),
                        'main-table__row--title-forecast': _unref(mainStore).forecastStatusDisplay}])
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["expand-button", { 'expand-button--expanded': isDistrictExpanded(districtKey as DistrictKey) }]),
                      onClick: ($event: any) => (toggleDistrictExpansion(districtKey as DistrictKey))
                    }, [
                      _createVNode(IconChevronUp)
                    ], 10, _hoisted_4),
                    _createTextVNode(" " + _toDisplayString(districtName.full), 1)
                  ]),
                  (_unref(mainStore).forecastStatusDisplay)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([{'main-table__col--forecast': _unref(mainStore).forecastStatusDisplay}, "main-table__col main-table__col--spacer"])
                      }, null, 2))
                    : _createCommentVNode("", true)
                ], 2),
                (isDistrictExpanded(districtKey as DistrictKey))
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getRegionsForDistrict(districtKey as DistrictKey), (row) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: row.file_id
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["main-table__row main-table__row--title main-table__row--title-nested", { 'main-table__row--with-scroll': hasScroll.value,
                            'main-table__row--expanded': isRowExpanded(row.file_id),
                            'main-table__row--title-nested-forecast': _unref(mainStore).forecastStatusDisplay}])
                        }, [
                          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "main-table__col main-table__col--spacer" }, null, -1)),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["expand-button", { 'expand-button--expanded': isRowExpanded(row.file_id) }]),
                              onClick: ($event: any) => (toggleRowExpansion(row.file_id))
                            }, [
                              _createVNode(IconChevronUp)
                            ], 10, _hoisted_6),
                            _createTextVNode(" " + _toDisplayString(getRegionName(row.region)), 1)
                          ]),
                          (_unref(mainStore).forecastStatusDisplay)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([{'main-table__col--forecast': _unref(mainStore).forecastStatusDisplay}, "main-table__col main-table__col--spacer"])
                              }, null, 2))
                            : _createCommentVNode("", true)
                        ], 2),
                        (isRowExpanded(row.file_id))
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getRowParameters(row), (param) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: param.key
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["main-table__row main-table__row--data main-table__row--data-district", { 'main-table__row--with-scroll': hasScroll.value, 'main-table__row--data-district-forecast': _unref(mainStore).forecastStatusDisplay }])
                                }, [
                                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "main-table__col main-table__col--spacer" }, null, -1)),
                                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "main-table__col main-table__col--spacer" }, null, -1)),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["main-table__col", { 'main-table__col--expandable': hasNestedParams(param.key) }])
                                  }, [
                                    (hasNestedParams(param.key))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: _normalizeClass(["expand-button expand-button--nested", { 'expand-button--expanded': isParamExpanded(`${row.file_id}-${param.key}`) }]),
                                          onClick: ($event: any) => (toggleParamExpansion(`${row.file_id}-${param.key}`))
                                        }, [
                                          _createVNode(IconChevronUp)
                                        ], 10, _hoisted_7))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(getParameterName(param.key)), 1)
                                  ], 2),
                                  _createElementVNode("div", _hoisted_8, _toDisplayString(param.value.reporting_period), 1),
                                  _createElementVNode("div", _hoisted_9, _toDisplayString(param.value.previous_year), 1),
                                  _createElementVNode("div", _hoisted_10, _toDisplayString(param.value.percent_to_previous_year), 1),
                                  (_unref(mainStore).forecastStatusDisplay)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass([{'main-table__col--forecast': _unref(mainStore).forecastStatusDisplay}, "main-table__col main-table__col--value"])
                                      }, _toDisplayString(_unref(mainStore).currentForecast.regions?.[row.region]?.[param.key].prediction_value ?? 0), 3))
                                    : _createCommentVNode("", true)
                                ], 2),
                                (hasNestedParams(param.key) && isParamExpanded(`${row.file_id}-${param.key}`))
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getNestedParams(row, param.key), (nestedParam) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: nestedParam.key,
                                        class: _normalizeClass(["main-table__row main-table__row--data main-table__row--nested main-table__row--nested-district", { 'main-table__row--with-scroll': hasScroll.value, 'main-table__row--nested-district-forecast': _unref(mainStore).forecastStatusDisplay }])
                                      }, [
                                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "main-table__col main-table__col--spacer" }, null, -1)),
                                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "main-table__col main-table__col--spacer" }, null, -1)),
                                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "main-table__col main-table__col--spacer" }, null, -1)),
                                        _createElementVNode("div", _hoisted_11, _toDisplayString(getParameterName(nestedParam.key)), 1),
                                        _createElementVNode("div", _hoisted_12, _toDisplayString(nestedParam.value.reporting_period), 1),
                                        _createElementVNode("div", _hoisted_13, _toDisplayString(nestedParam.value.previous_year), 1),
                                        _createElementVNode("div", _hoisted_14, _toDisplayString(nestedParam.value.percent_to_previous_year), 1),
                                        (_unref(mainStore).forecastStatusDisplay)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass([{'main-table__col--forecast': _unref(mainStore).forecastStatusDisplay}, "main-table__col main-table__col--value"])
                                            }, _toDisplayString(_unref(mainStore).currentForecast.regions?.[row.region]?.[nestedParam.key].prediction_value ?? 0), 3))
                                          : _createCommentVNode("", true)
                                      ], 2))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.items, (row) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: row.file_id
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["main-table__row main-table__row--title", { 'main-table__row--with-scroll': hasScroll.value,
                        'main-table__row--expanded': isRowExpanded(row.file_id),
                        'main-table__row--title-forecast': _unref(mainStore).forecastStatusDisplay}])
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["expand-button", { 'expand-button--expanded': isRowExpanded(row.file_id) }]),
                      onClick: ($event: any) => (toggleRowExpansion(row.file_id))
                    }, [
                      _createVNode(IconChevronUp)
                    ], 10, _hoisted_16),
                    _createTextVNode(" " + _toDisplayString(getRegionName(row.region)), 1)
                  ]),
                  (_unref(mainStore).forecastStatusDisplay)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([{'main-table__col--forecast': _unref(mainStore).forecastStatusDisplay}, "main-table__col main-table__col--spacer"])
                      }, null, 2))
                    : _createCommentVNode("", true)
                ], 2),
                (isRowExpanded(row.file_id))
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getRowParameters(row), (param) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: param.key
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["main-table__row main-table__row--data", { 'main-table__row--with-scroll': hasScroll.value, 'main-table__row--forecast': _unref(mainStore).forecastStatusDisplay }])
                        }, [
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "main-table__col main-table__col--spacer" }, null, -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["main-table__col", { 'main-table__col--expandable': hasNestedParams(param.key) }])
                          }, [
                            (hasNestedParams(param.key))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["expand-button expand-button--nested", { 'expand-button--expanded': isParamExpanded(`${row.file_id}-${param.key}`) }]),
                                  onClick: ($event: any) => (toggleParamExpansion(`${row.file_id}-${param.key}`))
                                }, [
                                  _createVNode(IconChevronUp)
                                ], 10, _hoisted_17))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(getParameterName(param.key)), 1)
                          ], 2),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(param.value.reporting_period), 1),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(param.value.previous_year), 1),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(param.value.percent_to_previous_year), 1),
                          (_unref(mainStore).forecastStatusDisplay)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([{'main-table__col--forecast': _unref(mainStore).forecastStatusDisplay}, "main-table__col main-table__col--value"])
                              }, _toDisplayString(_unref(mainStore).currentForecast.regions?.[row.region]?.[param.key].prediction_value ?? 0), 3))
                            : _createCommentVNode("", true)
                        ], 2),
                        (hasNestedParams(param.key) && isParamExpanded(`${row.file_id}-${param.key}`))
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getNestedParams(row, param.key), (nestedParam) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: nestedParam.key,
                                class: _normalizeClass(["main-table__row main-table__row--data main-table__row--nested", { 'main-table__row--with-scroll': hasScroll.value, 'main-table__row--forecast-nested': _unref(mainStore).forecastStatusDisplay }])
                              }, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "main-table__col main-table__col--spacer" }, null, -1)),
                                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "main-table__col main-table__col--spacer" }, null, -1)),
                                _createElementVNode("div", _hoisted_21, _toDisplayString(getParameterName(nestedParam.key)), 1),
                                _createElementVNode("div", _hoisted_22, _toDisplayString(nestedParam.value.reporting_period), 1),
                                _createElementVNode("div", _hoisted_23, _toDisplayString(nestedParam.value.previous_year), 1),
                                _createElementVNode("div", _hoisted_24, _toDisplayString(nestedParam.value.percent_to_previous_year), 1),
                                (_unref(mainStore).forecastStatusDisplay)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass([{'main-table__col--forecast': _unref(mainStore).forecastStatusDisplay}, "main-table__col main-table__col--value"])
                                    }, _toDisplayString(_unref(mainStore).currentForecast.regions?.[row.region]?.[nestedParam.key].prediction_value ?? 0), 3))
                                  : _createCommentVNode("", true)
                              ], 2))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
        (!__props.loading && props.items.length === 0)
          ? (_openBlock(), _createBlock(TableEmptyData, { key: 2 }))
          : _createCommentVNode("", true),
        (__props.loading)
          ? (_openBlock(), _createBlock(TableLoader, {
              key: 3,
              position: "absolute"
            }))
          : _createCommentVNode("", true)
      ], 512)
    ])
  ]))
}
}

})